/** 플랫 일러스트 — `public/images/illust/` */
const DIR = '/images/illust'

export const illust = {
  /** 도시 스트립 — 외부 사이트와 구도가 비슷해 메인 게이트에는 쓰지 않음 */
  cityStrip: `${DIR}/city-strip.png`,
  /** 요양원 · 주간보호 */
  facility: `${DIR}/facility.png?v=2`,
  /** 방문요양 */
  visit: `${DIR}/visit.png?v=2`,
  /** 임금 · 통상임금 · 대장 */
  wage: `${DIR}/wage.png`,
  /** 회계 · 예결산 */
  accounting: `${DIR}/accounting.png`,
  /** 상담 · 진단 */
  consult: `${DIR}/consult.png`,
  /** 함우리몰 · 공동구매 */
  mall: `${DIR}/mall.png`,
  /** 고객센터 · 문의 */
  support: `${DIR}/support.png`,
  /** 빈 목록 · 검색 없음 */
  empty: `${DIR}/empty.png`,
  /** 정보마당 준비중 */
  infoPreparing: `${DIR}/info-preparing.png`,
  /** 공지 · 소식 */
  notice: `${DIR}/notice.png`,
  /** 우측 하단 안내 열기 버튼 */
  helpLauncher: `${DIR}/help-launcher.png`,
  /** 파트너 · 기관 소개 */
  partner: `${DIR}/partner.png`,
  /** 그림체 원본 레퍼런스 (검정 배경 — 생성 시 배경색은 쓰지 말 것) */
  styleRef: `${DIR}/style-ref.png`,
} as const

export type IllustKey = keyof typeof illust
